import React from 'react';
import '../App.less';
import { Link } from "react-router-dom";
import { 
    Button,
    Image,
    Typography, 
    Divider, 
    Statistic,
    Tag,
    Row, 
    Col,
    Space,
    PageHeader,
    Avatar,
    Alert
} from 'antd';

import { AntDesignOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;



function Pinaza() {
  return (
    <div>
        <Row className="m48-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <div className="">
                    <Row className="m24-b">
                        <Link to="/">
                            <PageHeader
                                onBack={() => null}
                                title="Back to Home"
                            />
                        </Link>
                    </Row>

                    <Row className="m16-b">
                        <Title>Pinaza</Title>
                    </Row>

                    <Row className="m24-b m24-t">
                        <Text>
                            Pinaza is a speculative design project imagining an underwater future in 2147 where scarce energy is being rationed within the community with a focus on exploring meaningful connections.
                        </Text>  
                    </Row>

                    <Row justify="space-between">
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Advisors</Text>
                                <Text className="bitDesc">
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/vanessajcarpenter/" target="_blank" rel="noopener noreferrer">Vanessa Julia Carpenter</a>,
                                    <a className="nameLinkColor" href=" http://blog.dzl.dk/" target="_blank" rel="noopener noreferrer"> Nikolaj “Dzl” Møbius</a>,
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/olivia-prior-577325153/" target="_blank" rel="noopener noreferrer"> Olivia Prior</a>, 
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/omid-ettehadi/" target="_blank" rel="noopener noreferrer"> Omid Ettehadi</a>
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                            <   Text className="bitTitle">Team</Text>
                                <Text className="bitDesc">
                                    <a className="nameLinkColor" href="https://dianapang.net/" target="_blank" rel="noopener noreferrer">Diana Pang</a>,
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/christoff-trexler-11bb31107/" target="_blank" rel="noopener noreferrer"> Christoff Trexler</a>
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Sustainable development goals</Text>
                                <Space className="m8-t">
                                    <Image className="sdgImage" src={`../pubAssets/sdg-7.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-9.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-10.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-11.png`}/>
                                </Space>
                                <Space className="m8-t">
                                    <Image className="sdgImage" src={`../pubAssets/sdg-12.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-13.png`}/>
                                </Space>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Tags</Text>
                                <Space size={1}>
                                    <Tag>Processing</Tag>
                                    <Tag>Arduino</Tag>
                                </Space>
                                <Space size={1}>
                                    <Tag>IoT</Tag>
                                </Space>
                            </Space>
                        </Col>
                    </Row>

                    
                </div>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
        <Row>
            <Col span={24}>
                    <div className="videoHeight">
                        <iframe src="https://player.vimeo.com/video/475166162?title=0&byline=0&portrait=0" className="vimeoChild" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                    </div>
            </Col>  
        </Row>
        
        <Row className="m80-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical" className="m80-t">
                            <Text className="projectTitle">challenge</Text>
                            <Text>
                                To choose one of the aspects of meaningfulness and develop a high-fidelity prototype that explores your chosen manifestation through the form of a TUI in the context of Costa Rica. There is no restriction on the use of networking technology or limitation on range.
                            </Text>
                        </Space>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical" className="m80-t">
                            <Text className="projectTitle">outcome</Text>
                            <Text>
                                The project explores different aspects of meaningful connections including:
                                <ul>
                                    <li><strong>People-to-people</strong> - Power is shared by all, how does your consumption relate to the community?</li>
                                    <li><strong>People-to-self</strong> - Reflecting and bringing awareness on one’s energy consumption</li>
                                    <li><strong>People-to-time</strong> - How does one decide on how to budget limited resources in the short term (a day) vs. long term (6 months)?</li>
                                </ul>
                            </Text>
                        </Space>
                    </Col>
                </Row>
                
                <Row className="m80-t">
                    <Text className="projectTitle">Inspiration</Text>
                    <Text className="m16-b m16-t">We drew inspiration from the Diquis spheres, ancient stone spheres that are found throughout Costa Rica with unknown origins and theorized to be calendar markers, symbols of power, or meeting points. We were fascinated by the discovery story where these spheres were stumbled upon by an American fruit company while clearing land for banana plantations and workmen blew them apart in hopes of extracting hidden gold inside.</Text>
                    <Image width="100%" src={require("../assets/projects/pinaza/pinaza_1.png")}/>
                    <Text className="m48-t m16-b">Through secondary research, future-casting, and world-building, we imagined a world with rising sea levels where coastal populations who cannot afford to flee inland are confined to living underwater in disused research stations where energy is being rationed as the communal energy collection system only gathers solar energy once every six months. These communal energy spheres power households and inhabitants can budget for their daily use by carrying their personal energy with them.</Text>
                    <Text className="m16-t m80-b">It is estimated that by the year 2100, sea levels could rise between 2.5 meters and 5 meters and may rise even further by 2150. Millions are expected to be displaced as 11% of the world’s population live less than 11 meters above sea level.</Text>

                    <Text className="projectTitle">Concept</Text>
                    

                    <Row justify="space-between">
                        <Col xs={24} sm={24} md={24} lg={18} xl={18}>
                            <Space direction="vertical">
                                <div className="m16-t"><Text>The year is 2147. With rising sea levels, coastal populations who cannot afford to flee inland nor off-planet are now confined to living underwater in disused research stations, while rich nations have developed floating habitats.  </Text></div>
                                <div className="m16-t"><Text>With underwater research stations hastily converted into dwellings, insufficient planning and overpopulation have led to an energy crisis. To cope with energy rationing, Nautilus II developed communal energy spheres which power households, where individuals can budget for their daily use. </Text></div>
                                <div className="m16-t"><Text>Energy consumption is now being accounted for on an individual energy basis. Each person carries their own personal device around </Text></div>
                            </Space>  
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5} className="m24-t">
                            <Image  src={require("../assets/projects/pinaza/pinaza_7.png")}/>
                        </Col>                      
                    </Row>

                    

                    <Row className="m80-t" justify="space-between">
                        <Col xs={24} sm={24} md={24} lg={6} xl={6} className="m48-t">
                            <Image src={require("../assets/projects/pinaza/pinaza_8.png")}/>
                            <div className="m16-t"><Text><strong>Collection</strong></Text></div>
                            <div><Text>The sphere goes up to the surface once every 6 months to gather solar energy</Text></div>
                        </Col>
                        
                        <Col xs={24} sm={24} md={24} lg={6} xl={6} className="m48-t">
                            <Image src={require("../assets/projects/pinaza/pinaza_9.png")}/>
                            <div className="m16-t"><Text><strong>Transfer</strong></Text></div>
                            <div><Text>As the sphere transmits energy to the household base, it collapses in on itself as a visual of how much energy is left</Text></div>
                        </Col>
                        
                        <Col xs={24} sm={24} md={24} lg={6} xl={6} className="m48-t">
                            <Image src={require("../assets/projects/pinaza/pinaza_10.png")}/>
                            <div className="m16-t"><Text><strong>Charging</strong></Text></div>
                            <div><Text>Each person in a household places their hand on their spheres on the base to charge them</Text></div>
                        </Col>
                        
                        <Col xs={24} sm={24} md={24} lg={5} xl={5} className="m48-t">
                            <Image src={require("../assets/projects/pinaza/pinaza_11.png")}/>
                            <div className="m16-t"><Text><strong>Usage</strong></Text></div>
                            <div><Text>People are able to carry around their personal spheres to be used to power personal recreational devices</Text></div>
                        </Col>
                    </Row>
                    <Text className="m16-t m16-b"></Text>


                </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>

        
        <Row className="whiteBG">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row  className="m80-t m24-b">
                    <Title className="whiteBGTitle">Prototype</Title>
                </Row>
                <Row justify="space-between">
                    <Col xs={22} sm={22} md={22} lg={8} xl={8}>
                            <Text className="whiteBGTitle">
                                The communal energy sphere was built using a relay module to link up an air pump with an Arduino Nano33 IoT, allowing the ball to inflate and deflate at a controlled rate (visual representation for communal energy consumption). The smaller handheld ball is made up of neopixel rings and Arduino Nano33 IoT boards to show the consumption of personal energy through dimming and glowing lights (when placed on the household base for recharging).
                            </Text>
                    </Col>
                    <Col xs={22} sm={22} md={22} lg={15} xl={15}>
                        <div>
                            <Image src={require("../assets/projects/pinaza/pinaza_2.gif")}/>
                            <div  className="m16-t m16-b">
                                <Text  className="whiteBGTitle imgDesc">
                                    Trying out various forms for the spheres which could collapse and expand
                                </Text>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Space size={16} align="start" className="m16-t m24-b">
                        <div>
                            <Image src={require("../assets/projects/pinaza/pinaza_3.gif")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Sharing of energy to smaller spheres - main sphere deflating at the same time
                                </Text>
                            </div>
                        </div>
                        <div>
                            <Image src={require("../assets/projects/pinaza/pinaza_4.gif")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Imagining what an underwater scenario it might be
                                </Text>
                            </div>
                        </div>
                    </Space>
                    <Space size={16} align="start" className="m16-t m24-b">
                        <div>
                            <Image src={require("../assets/projects/pinaza/pinaza_5.gif")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Studio setup for recording prototype video
                                </Text>
                            </div>
                        </div>
                        <div>
                            <Image src={require("../assets/projects/pinaza/pinaza_6.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Communal sphere and individual spheres mounted on their bases
                                </Text>
                            </div>
                        </div>
                    </Space>
                    <Space size={16} align="start" className="m16-t m24-b">
                        <div>
                            <Image src={require("../assets/projects/pinaza/pinaza_13.gif")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Communal sphere deflating as energy is distributed
                                </Text>
                            </div>
                        </div>
                        <div>
                            <Image src={require("../assets/projects/pinaza/pinaza_12.jpeg")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Fully charged communal sphere
                                </Text>
                            </div>
                        </div>
                    </Space>
                    <Space size={16} align="start" className="m16-t m24-b">
                        <div>
                            <Image src={require("../assets/projects/pinaza/pinaza_14.gif")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Charging individual spheres
                                </Text>
                            </div>
                        </div>
                        <div>
                            <Image src={require("../assets/projects/pinaza/pinaza_15.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Longer the hand is placed, more energy is transferred
                                </Text>
                            </div>
                        </div>
                    </Space>
                    <Space size={16} align="start" className="m16-t m24-b">
                        <div>
                            <Image src={require("../assets/projects/pinaza/pinaza_16.gif")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Individual spheres are mobile and can be taken anywhere
                                </Text>
                            </div>
                        </div>
                        <div>
                            <Image src={require("../assets/projects/pinaza/pinaza_17.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    The number of people in a room could supply energy for their collective activities
                                </Text>
                            </div>
                        </div>
                    </Space>
                    <Space size={16} align="start" className="m16-t m80-b">
                        <div>
                            <Image src={require("../assets/projects/pinaza/pinaza_18.png")}/>
                            <div  className="m16-t">
                                <Text  className="whiteBGTitle imgDesc">
                                    Connection using nano IOT 33 and firebase
                                </Text>
                            </div>
                        </div>
                    </Space>
                </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
        
        <Row className="m80-t m80-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical">
                        <Text className="projectTitle m16-b">Learnings from prototype</Text>
                            <Text>
                                <ul>
                                    <li>How to come up with hacky solutions in lieu of resources</li>
                                    <li>Using relay to hack an existing object</li>
                                    <li>Speculative design framework for future-casting and back-casting</li>
                                    <li>World Building and concepts of aquatic dwellings</li>
                                </ul>
                            </Text>
                        </Space>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical">
                            <Text className="projectTitle m16-b">Future considerations</Text>
                            <Text>
                                <ul>
                                    <li>Connected spheres</li>
                                    <li>Deeper dive into the wearable aspect</li>
                                    <li>Other speculative design frameworks</li>
                                    <li>Explore more the logistics of floating dwellings</li>
                                    <li>Consider human psychology of living in confined spaces for extended periods of time</li>
                                    <li>How to explore user testing with speculative design</li>
                                </ul>
                            </Text>
                        </Space>
                    </Col>
                </Row>

            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
    </div>
  );
}

export default Pinaza;